module.exports = __webpack_public_path__ + "static/media/danna.d97531c7.jpg";